import { render } from "./ShellContainer.vue?vue&type=template&id=4120376e"
import script from "./ShellContainer.vue?vue&type=script&lang=js"
export * from "./ShellContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__